import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import $ from "jquery"; // Still included if you use it elsewhere for preloader
import authBg from "../../assets/images/big/auth-bg.jpg";
import { useDispatch, useSelector } from "react-redux";
import { errorMessage, successMessage } from "../../utils/tostify";
import logo from "../../assets/images/logo.png";
import { createFormData } from "../../utils/common"; // Assuming this utility function is correct
import CryptoJS from "crypto-js";
import { registermember, savemembershippayment, sendverificationLink } from "../../store/slices/userSlice";
import Swal from "sweetalert2";
import { getallmembershiptypes } from "../../services/dbService"; // Corrected to use getallmembershiptypes
import { usStates } from "../../services/states";
import { useNavigate } from "react-router-dom"; // Import useNavigate

function Registration() {
  const { error, status } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate hook
  const [showPassword, setShowPassword] = useState(false);
  const [membershipTypes, setMembershipTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Hide preloader initially
    $(".preloader").fadeOut();
  }, []);

  // Removed status-based success/error messages here.
  // We'll use Swal.fire for more controlled user feedback after registration.
  // useEffect(() => {
  //   if (status === "failed") {
  //     errorMessage(error);
  //   }
  //   if (status === "succeeded") {
  //     successMessage("Registration Complete");
  //   }
  // }, [error, status]);

  // Fetch membership types on component mount
  useEffect(() => {
    fetchMembershipTypes();
  }, []);

  const fetchMembershipTypes = async () => {
    setLoading(true);
    try {
      const response = await getallmembershiptypes();
      if (response?.status === 200 && Array.isArray(response.data)) {
        // Filter for active status, assuming 'status' is a string '1'
        setMembershipTypes(response.data.filter((type) => type.status === "1"));
      } else {
        Swal.fire("Error", "Error fetching membership types!", "error");
      }
    } catch (error) {
      console.error("Error fetching membership types:", error);
      Swal.fire("Error", "Error fetching membership types!", "error");
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      mobile: "",
      firstname: "",
      lastname: "",
      password: "",
      confirmPassword: "",
      addressline1: "",
      addressline2: "",
      addressline3: "",
      state: "",
      zipcode: "",
      membershiptype: "", // Maps to PayPal plan_id
      amount: 0, // Display only, not sent to PayPal directly for subscriptions
      role: "user", // Default role
      spousefirstname: "",
      spouselastname: "",
      status:1
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Phone must be a valid 10-digit number")
        .required("Phone is required"),
      firstname: Yup.string().required("First Name is required"),
      lastname: Yup.string().required("Last Name is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Please re-enter your password"),
      addressline1: Yup.string().required("Address Line 1 is required"),
      addressline2: Yup.string(),
      addressline3: Yup.string(),
      state: Yup.string().required("State is required"),
      zipcode: Yup.string()
        .matches(
          /^\d{5}(?:[-\s]\d{4})?$/,
          "Invalid Zip Code (e.g., 12345 or 12345-6789)"
        )
        .required("Zipcode is required"),
      membershiptype: Yup.string().required("Membership type is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true); // Show loading spinner during submission
      const encryptedPassword = CryptoJS.SHA256(values.password).toString();

      const today = new Date();
     // new Date().toLocaleDateString('en-CA')
     // const formattedDate = today.toISOString().split('T')[0]; // "yyyy-MM-dd"
      const formattedDate = today.toLocaleDateString('en-CA');

      const finalValues = {
        ...values,
        password: encryptedPassword,
        confirmPassword: undefined, 
        validUpto: undefined, 
        validupto: formattedDate,
      };

      try {
        const actionResult = await dispatch(
          registermember(createFormData(finalValues))
        );
        const response = unwrapResult(actionResult); // Get the actual payload from Redux Thunk

         
        if (response?.status === 200 && response.data?.id) {
          // Registration successful
          const selectedMembership = membershipTypes.find(
            (type) => type.id === values.membershiptype
          );

          if (!selectedMembership) {
            Swal.fire("Error", "Selected membership type not found. Please choose a valid type.", "error");
            setLoading(false);
            return;
          }

          // Save pending payment record to your database BEFORE redirecting to PayPal.
          // The actual payment status will be updated by your backend after PayPal webhook/return.
          
       

        setLoading(false); 
          // if (paymentResponse?.status === 200)
          // {
            Swal.fire({
              title: "Registration Successful!",
              text: "Your account has been created. Please complete your subscription to activate your membership.",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Proceed to Payment",
              cancelButtonText: "Later",
              allowOutsideClick: false,
            }).then((result) => {
              
              if (result.isConfirmed) {
                // Redirect to the payment page, passing user ID and selected PayPal Plan ID

                navigate('/payment', {
                  state: {
                    userId: response.data.id, 
                    membershipType: selectedMembership.id,
                    amount:selectedMembership.amount,
                    validupto:formik.values.validUpto
                  }
                });
              } else {
                Swal.fire("Success", "You can complete the payment later by logging in.", "info");
                navigate('/login'); // Redirect to login or a "pay later" page
              }
            });
          // }




          // Send verification link
          // await dispatch(sendverificationLink({
          //   id: response.data.id,
          //   email: response.data.email
          // }));

          // setLoading(false); // Hide loading before showing alert

          // Show success message and prompt for payment
          

        } else {
          setLoading(false); // Hide loading on registration failure
          Swal.fire(
            "Error",
            response?.data?.message || "Registration failed. Please try again.",
            "error"
          );
        }
      } catch (error) {
        setLoading(false); // Hide loading on error
        console.error("Error during registration:", error);
        errorMessage("Registration failed. Please try again.");
      }
    },
  });

  // Helper to unwrap Redux Toolkit async thunk results
  function unwrapResult(result) {
    if (result.payload) {
      return result.payload;
    } else if (result.error) {
      // It's good practice to throw the error so catch block handles it
      throw result.error;
    }
    return result; // Fallback, though usually payload or error is present
  }

  // Handle membership type selection change
  // const handleMembershipTypeChange = (e) => {
  //   const selectedMembershipId = e.target.value;
  //   const selectedType = membershipTypes.find(
  //     (type) => type.id === selectedMembershipId
  //   );

  //   formik.handleChange(e); // Let Formik handle the 'membershiptype' field

  //   if (selectedType) {
  //     // Calculate validUpto for display (it will be dynamic with subscription)
  //     const today = new Date();
  //     // Parse duration as integer. If duration is in 'days', add that many days.
  //     // Adjust if 'duration' is in months, years, etc.
  //     const duration = parseInt(selectedType.duration);
  //     if (!isNaN(duration)) {
  //       today.setDate(today.getDate() + duration);
  //       formik.setFieldValue("validUpto", today.toISOString().split("T")[0]); // Format as YYYY-MM-DD
  //     } else {
  //       formik.setFieldValue("validUpto", ""); // Clear if duration is invalid
  //     }
  //     formik.setFieldValue("amount", parseFloat(selectedType.amount)); // Set amount for display
  //   } else {
  //     formik.setFieldValue("validUpto", "");
  //     formik.setFieldValue("amount", 0);
  //   }
  // };

  const handleMembershipTypeChange = (e) => {
    const selectedMembershipId = e.target.value;
    const selectedType = membershipTypes.find(
      (type) => type.id === selectedMembershipId
    );
  
    formik.handleChange(e);
  
    if (selectedType) {
      let baseDateForAddingDuration; // This will be the date after the initial +1 month from localStorage
      const currentValidUpto = localStorage.getItem('validupto'); // NOW Expecting YYYY-MM-DD
  
      console.log("currentValidUpto", currentValidUpto);

      if (currentValidUpto) {
        const parts = currentValidUpto.split('-'); // YYYY-MM-DD
        if (parts.length === 3) {
          const year = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; // JS months are 0-based
          const day = parseInt(parts[2], 10);
  
          // 1. Construct UTC base date from localStorage value
          let initialDateFromLocalStorage = new Date(Date.UTC(year, month, day));
          console.log("1. Initial date from localStorage (UTC):", initialDateFromLocalStorage.toISOString());
  
          // 2. Add exactly one month to the initial date
          baseDateForAddingDuration = new Date(initialDateFromLocalStorage.getTime()); // Clone
          baseDateForAddingDuration.setUTCMonth(baseDateForAddingDuration.getUTCMonth() + 1);
  
          console.log("2. Base date after initial +1 month (UTC):", baseDateForAddingDuration.toISOString());
  
        } else {
          console.warn("Invalid 'validupto' format. Using today + 1 month as base.");
          const today = new Date();
          baseDateForAddingDuration = new Date(Date.UTC(
            today.getUTCFullYear(),
            today.getUTCMonth() + 1,
            today.getUTCDate()
          ));
        }
      } else {
        console.warn("'validupto' not found. Using today + 1 month as base.");
        const today = new Date();
        baseDateForAddingDuration = new Date(Date.UTC(
          today.getUTCFullYear(),
          today.getUTCMonth() + 1,
          today.getUTCDate()
        ));
      }
  
      const durationInDaysFromType = parseInt(selectedType.duration, 10);
      let monthsToAddFromType;
  
      // Conditional logic for 'duration'
      if (durationInDaysFromType === 30) {
          monthsToAddFromType = 0; // Special case: For duration 30, add 0 additional months
          console.log("DEBUG: Special rule applied: For duration 30, adding 0 additional months.");
      } else {
          monthsToAddFromType = (durationInDaysFromType / 30)-1; // General case: Calculate additional months
          console.log("DEBUG: General rule applied: Calculating months from duration / 30.");
      }
  
      console.log("DEBUG: selectedType.duration =", selectedType.duration);
      console.log("DEBUG: durationInDaysFromType (parsed) =", durationInDaysFromType);
      console.log("DEBUG: monthsToAddFromType (calculated for membership type) =", monthsToAddFromType);
  
      // Helper function to add months, handling day overflow (e.g., Jan 30 + 1 month = Feb 28)
      function addUTCMonthsSafely(date, months) {
          const d = new Date(date.getTime()); // Clone the date
          const originalDay = d.getUTCDate();
          d.setUTCMonth(d.getUTCMonth() + months); // Add months
  
          const lastDayOfTargetMonth = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
          if (originalDay > lastDayOfTargetMonth) {
              d.setUTCDate(lastDayOfTargetMonth);
          }
          return d;
      }
  
      // Apply the monthsToAddFromType using the safe helper
      let finalValidUptoDate = addUTCMonthsSafely(baseDateForAddingDuration, monthsToAddFromType);
  
      console.log("3. Final Valid Upto Date (UTC - before last day adjustment):", finalValidUptoDate.toISOString());
      
      // ✅ NEW LOGIC: Set the day to the last day of its current month
      finalValidUptoDate.setUTCDate(new Date(Date.UTC(finalValidUptoDate.getUTCFullYear(), finalValidUptoDate.getUTCMonth() + 1, 0)).getUTCDate());
      console.log("4. Final Valid Upto Date (UTC - after last day adjustment):", finalValidUptoDate.toISOString());

      // Format as MM-DD-YYYY using UTC values (output format remains the same)
      const year = finalValidUptoDate.getUTCFullYear();
      const month = String(finalValidUptoDate.getUTCMonth() + 1).padStart(2, '0');
      const day = String(finalValidUptoDate.getUTCDate()).padStart(2, '0');
      const formattedValidUpto = `${month}-${day}-${year}`;
  
      console.log("Formatted Valid Upto:", formattedValidUpto);
  
      formik.setFieldValue("validUpto", formattedValidUpto);
      formik.setFieldValue("amount", parseFloat(selectedType.amount));
    } else {
      formik.setFieldValue("validUpto", "");
      formik.setFieldValue("amount", 0);
    }
  };

  return (
    <div className="main-wrapper">
      {loading && (
        <div className="preloader" style={{ display: "block" }}>
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}
      <div
        className="auth-wrapper d-flex no-block justify-content-center align-items-center position-relative"
        style={{ background: `url(${authBg}) no-repeat center center` }}
      >
        <div className="auth-box row">
          <div className="col-lg-12 col-md-8 bg-white">
            <div className="p-3">
              <div className="text-center">
                <img src={logo} width="100%" alt="Logo" />
                <h2 className="mt-3">Member Registration</h2>
              </div>
              <form className="mt-4" onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/* Membership Type Dropdown */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="membershiptype"
                      >
                        Membership Type
                      </label>
                      <select
                        id="membershiptype"
                        className={`form-control ${
                          formik.touched.membershiptype &&
                          formik.errors.membershiptype
                            ? "is-invalid"
                            : ""
                        }`}
                        {...formik.getFieldProps("membershiptype")}
                        onChange={handleMembershipTypeChange} // Custom handler
                      >
                        <option value="">Select Membership Type</option>
                        {membershipTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name} - {type.duration} days - ${type.amount}
                          </option>
                        ))}
                      </select>
                      {formik.touched.membershiptype &&
                        formik.errors.membershiptype && (
                          <div className="invalid-feedback">
                            {formik.errors.membershiptype}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Valid Upto (Display only, calculated) */}
                  {formik.values.membershiptype && ( // Show only if a type is selected
                    <div className="col-lg-6">
                      <div className="form-group mb-3">
                        <label
                          className="form-label text-dark"
                          htmlFor="validUpto"
                        >
                          Estimated Valid Upto
                        </label>
                        <input
                          id="validUpto"
                          type="text"
                          className="form-control"
                          value={formik.values.validUpto}
                          readOnly // Make it read-only
                        />
                      </div>
                    </div>
                  )}

                  {/* Email */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="email">
                        Email
                      </label>
                      <input
                        id="email"
                        type="email"
                        className={`form-control ${
                          formik.touched.email && formik.errors.email
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your email"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="invalid-feedback">
                          {formik.errors.email}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Mobile */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="mobile">
                        Phone
                      </label>
                      <input
                        id="mobile"
                        type="text"
                        className={`form-control ${
                          formik.touched.mobile && formik.errors.mobile
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your mobile number"
                        {...formik.getFieldProps("mobile")}
                      />
                      {formik.touched.mobile && formik.errors.mobile && (
                        <div className="invalid-feedback">
                          {formik.errors.mobile}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* First Name */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="firstname">
                        First Name
                      </label>
                      <input
                        id="firstname"
                        type="text"
                        className={`form-control ${
                          formik.touched.firstname && formik.errors.firstname
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your first name"
                        {...formik.getFieldProps("firstname")}
                      />
                      {formik.touched.firstname && formik.errors.firstname && (
                        <div className="invalid-feedback">
                          {formik.errors.firstname}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="lastname">
                        Last Name
                      </label>
                      <input
                        id="lastname"
                        type="text"
                        className={`form-control ${
                          formik.touched.lastname && formik.errors.lastname
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your last name"
                        {...formik.getFieldProps("lastname")}
                      />
                      {formik.touched.lastname && formik.errors.lastname && (
                        <div className="invalid-feedback">
                          {formik.errors.lastname}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Spouse First Name */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="spousefirstname">
                        Spouse First Name (Optional)
                      </label>
                      <input
                        id="spousefirstname"
                        type="text"
                        className={`form-control ${
                          formik.touched.spousefirstname && formik.errors.spousefirstname
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your spouse first name"
                        {...formik.getFieldProps("spousefirstname")}
                      />
                      {formik.touched.spousefirstname && formik.errors.spousefirstname && (
                        <div className="invalid-feedback">
                          {formik.errors.spousefirstname}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Spouse Last Name */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="spouselastname">
                        Spouse Last Name (Optional)
                      </label>
                      <input
                        id="spouselastname"
                        type="text"
                        className={`form-control ${
                          formik.touched.spouselastname && formik.errors.spouselastname
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your spouse last name"
                        {...formik.getFieldProps("spouselastname")}
                      />
                      {formik.touched.spouselastname && formik.errors.spouselastname && (
                        <div className="invalid-feedback">
                          {formik.errors.spouselastname}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Password */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="password"
                      >
                        Password
                        <span
                          style={{
                            fontStyle: "italic",
                            color: "red",
                            fontSize: "12px",
                          }}
                        >
                          (Password should be 8 characters)
                        </span>
                      </label>
                      <div className="input-group">
                        <input
                          id="password"
                          type={showPassword ? "text" : "password"}
                          className={`form-control ${
                            formik.touched.password && formik.errors.password
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Enter your password"
                          {...formik.getFieldProps("password")}
                        />
                        <button
                          type="button" // Important: set type to button to prevent form submission
                          className="btn btn-light border"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <i className="fa-solid fa-eye"></i>
                          ) : (
                            <i className="fa-solid fa-eye-slash"></i>
                          )}
                        </button>
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="invalid-feedback">
                          {formik.errors.password}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="confirmPassword"
                      >
                        Re-enter Password
                      </label>
                      <input
                        id="confirmPassword"
                        type="password"
                        className={`form-control ${
                          formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Re-enter your password"
                        {...formik.getFieldProps("confirmPassword")}
                      />
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword && (
                          <div className="invalid-feedback">
                            {formik.errors.confirmPassword}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Address Line 1 */}
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="addressline1"
                      >
                        Address Line 1
                      </label>
                      <input
                        id="addressline1"
                        type="text"
                        className={`form-control ${
                          formik.touched.addressline1 &&
                          formik.errors.addressline1
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Apartment, suite, unit, building, floor, etc."
                        {...formik.getFieldProps("addressline1")}
                      />
                      {formik.touched.addressline1 &&
                        formik.errors.addressline1 && (
                          <div className="invalid-feedback">
                            {formik.errors.addressline1}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Address Line 2 */}
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="addressline2"
                      >
                        Address Line 2 (Optional)
                      </label>
                      <input
                        id="addressline2"
                        type="text"
                        className={`form-control ${
                          formik.touched.addressline2 &&
                          formik.errors.addressline2
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Optional address details"
                        {...formik.getFieldProps("addressline2")}
                      />
                      {formik.touched.addressline2 &&
                        formik.errors.addressline2 && (
                          <div className="invalid-feedback">
                            {formik.errors.addressline2}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Address Line 3 */}
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="addressline3"
                      >
                        Address Line 3 (Optional)
                      </label>
                      <input
                        id="addressline3"
                        type="text"
                        className={`form-control ${
                          formik.touched.addressline3 &&
                          formik.errors.addressline3
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="More optional address details"
                        {...formik.getFieldProps("addressline3")}
                      />
                      {formik.touched.addressline3 &&
                        formik.errors.addressline3 && (
                          <div className="invalid-feedback">
                            {formik.errors.addressline3}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* State Dropdown */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="state">
                        State
                      </label>
                      <select
                        id="state"
                        className={`form-control ${
                          formik.touched.state && formik.errors.state
                            ? "is-invalid"
                            : ""
                        }`}
                        {...formik.getFieldProps("state")}
                      >
                        <option value="">Select a State</option>
                        {usStates.map((state) => (
                          <option key={state.abbreviation} value={state.abbreviation}>
                            {state.name} ({state.abbreviation})
                          </option>
                        ))}
                      </select>
                      {formik.touched.state && formik.errors.state && (
                        <div className="invalid-feedback">
                          {formik.errors.state}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Zipcode */}
                  <div className="col-lg-6">
                    <div className="form-group mb-3">
                      <label
                        className="form-label text-dark"
                        htmlFor="zipcode"
                      >
                        Zip Code
                      </label>
                      <input
                        id="zipcode"
                        type="text"
                        className={`form-control ${
                          formik.touched.zipcode && formik.errors.zipcode
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter your Zip Code (e.g., 12345 or 12345-6789)"
                        {...formik.getFieldProps("zipcode")}
                      />
                      {formik.touched.zipcode && formik.errors.zipcode && (
                        <div className="invalid-feedback">
                          {formik.errors.zipcode}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12 text-center">
                    <button type="submit" className="btn w-100 btn-info" disabled={loading}>
                      {loading ? "Registering..." : "Register"}
                    </button>
                  </div>

                  {/* Navigation */}
                  <div className="text-center mt-5">
                    Already have an account?{" "}
                    <a href="/" className="text-danger">
                      Sign In
                    </a>
                  </div>
                  <div className="col-lg-12 text-center">
                    Forgot Your Password?{" "}
                    <a href="/forgot-password" className="text-danger">
                      Forgot Password?
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registration;